/**
 * The file Share dialog opened from a message's or the viewer's "…" menu (or the file page): loads the file's page
 * state (name, who can access it) and its sharing state, and renders FileShareDialog. Mounted only while open.
 */
import { Shell } from "@bundle/core";
import { useNavigation, useWorkspaceContext } from "../../context/AppContext.tsx";
import { useFilePlatform } from "../../context/FilesContext.tsx";
import { useFileShare } from "../../context/SharingContext.tsx";
import { useFile } from "../../hooks/files.ts";
import { FileShareDialog } from "./FileShareDialog.tsx";

export function FileShareSheet({ fileId, onClose }: { fileId: string; onClose: () => void }) {
  const share = useFileShare(fileId);
  const { state: file } = useFile(fileId);
  const platform = useFilePlatform();
  const nav = useNavigation();
  const { slug } = useWorkspaceContext();
  if (share === null) return null;
  const path = Shell.formatUrl({ type: "file", ws: slug, fileId });
  return (
    <FileShareDialog
      open
      onClose={onClose}
      vm={share.vm}
      state={share.state}
      fileName={file.file?.name ?? ""}
      access={file.audience}
      internalLink={path}
      onCopy={(text) => platform.copyLink(text)}
      onOpenConversation={(channelId) => {
        onClose();
        nav.open(Shell.formatUrl({ type: "channel", ws: slug, channelId }));
      }}
    />
  );
}
